export const LOSER_VARIANT = 'loser_variant';
export const MASTER = 'master';
export const VARIANT = 'variant';
export const ALL_VARIATIONS = 'all';